var _defs, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
;

var SvgBubbleCorner = function SvgBubbleCorner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 111.58 75.361"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bubble-corner_svg__bubble-corner_svg__linearGradient936",
    x1: -788.56,
    x2: -709.58,
    y1: -436.53,
    y2: -169.55,
    gradientTransform: "matrix(.92665 -.34084 .34084 .92665 1084.8 140.62)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    className: "bubble-corner_svg__bubble-corner_svg__gradient-primary-start",
    offset: 0,
    stopColor: "#6346bd"
  }), /*#__PURE__*/React.createElement("stop", {
    className: "bubble-corner_svg__bubble-corner_svg__gradient-primary-stop",
    offset: 1,
    stopColor: "#333b8c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bubble-corner_svg__bubble-corner_svg__linearGradient1340",
    x1: -787.02,
    x2: -727.49,
    y1: -398.21,
    y2: -145.82,
    gradientTransform: "matrix(.97186 -.17418 .17418 .97186 1041 271.3)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    className: "bubble-corner_svg__bubble-corner_svg__gradient-primary-start",
    offset: 0,
    stopColor: "#6346bd"
  }), /*#__PURE__*/React.createElement("stop", {
    className: "bubble-corner_svg__bubble-corner_svg__gradient-primary-stop",
    offset: 1,
    stopColor: "#333b8c"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bubble-corner_svg__bubble-corner_svg__linearGradient936)",
    d: "M17.021 0C3.34 80.848 50.695 201.53 123.971 265.03c56.668 44.102 140.92-4.807 203.69-39.688 28.697-15.948 61.157-33.88 94.064-53.357V.005h-404.7z",
    opacity: 0.66,
    transform: "scale(.26458)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bubble-corner_svg__bubble-corner_svg__linearGradient1340)",
    d: "M3.602 0c-5.076 74.205 21.053 166.63 69.553 226.4 48.117 53.3 139.6 19.818 207.49-3.594 42.32-14.596 92.154-31.583 141.08-51.4V-.004H3.605z",
    transform: "scale(.26458)"
  })));
};

;
export default SvgBubbleCorner;